export default "__VITE_ASSET__BYFZU1Dc__"